



































import Vue from 'vue';
import MaskedInput from './MaskedInput.vue';

export default Vue.extend({
    name: 'Input',

    components: { MaskedInput },

    inheritAttrs: false,

    props: {
        type: {
            type: String,
            default: 'text',
        },

        value: {
            type: [String, Number],
        },

        rows: {
            type: Number,
        },

        placeholder: {
            type: [String, Number],
            required: true,
        },

        error: {
            type: [String],
        },

        mask: {
            type: Object,
        },

        inputmode: {
            type: String,
        },
    },

    data() {
        return {
            focus: false,
        };
    },

    computed: {
        component() {
            if (this.rows) {
                return 'textarea';
            } else if (this.mask) {
                return 'masked-input';
            } else {
                return 'input';
            }
        },
    },

    methods: {
        onInput(event: InputEvent) {
            this.$emit('input', (event.target as HTMLInputElement).value);
        },
    },
});
